import { PagingResultsViewModel, FilterSearchingBaseViewModel } from 'src/app/components/core/_infrastructure/types/common';

export class TwSeriLogViewModel {
    public Id: number;
    public Message: '';
    public MessageTemplate: '';
    public Level: '';
    public TimeStamp: Date;
    public Exception: '';
    public Properties: '';
}

export class TwSeriLogItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: TwSeriLogItemViewModel[];
}

export class TwSeriLogItemViewModel {
    public Id: number;
    public Message: '';
    public MessageTemplate: '';
    public Level: '';
    public TimeStamp: Date;
    public Exception: '';
}

export class FilterSearchingTwSeriLogViewModel extends FilterSearchingBaseViewModel {
    public Message: '';
    public Level: '';
    public FechaDesde: Date;
    public FechaHasta: Date;
    public Exception: '';
}
